import { useSortable } from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import { CSS } from '@dnd-kit/utilities';
// eslint-disable-next-line import/no-unresolved
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import classNames from 'classnames';

interface ColumnProps {
  label: string;
  dataKey: string;
  width: number;
  cellRenderer?: (props: { rowData: any; cellData: any }) => React.ReactNode;
}

interface RowProps {
  index: number;
  style?: React.CSSProperties;
  rowId: number;
  columns?: ColumnProps[];
  classname?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

export interface RowContextProps {
  setActivatorNodeRef?: (element: HTMLElement | null) => void;
  listeners?: SyntheticListenerMap;
}

export const RowContext = React.createContext<RowContextProps>({});

export const DragRow: React.FC<RowProps> = props => {
  const { style, columns, rowId, children, classname, disabled } = props;

  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, isDragging } =
    useSortable({ id: rowId });

  const rowStyle: React.CSSProperties = {
    ...style,
    transform: CSS.Translate.toString(transform),
    transition: 'none',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  const contextValue = useMemo<RowContextProps>(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners]
  );

  return (
    <RowContext.Provider value={contextValue}>
      <div ref={setNodeRef} style={rowStyle} {...attributes}>
        <div
          className={classNames(`${classname && classname} drag__table-row`, {
            disabled,
          })}
        >
          {columns ? columns.map(column => column as any) : children}
        </div>
      </div>
    </RowContext.Provider>
  );
};
